import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { SiteHeader } from './SiteHeader'
import { SiteFooter } from './SiteFooter'
import s from './site.module.css'

/* Header, content, footer — the frame every screen sits in except the exam.

   One layout for the public pages and the signed-in portal alike: the two
   differ by route guard, not by chrome, and sharing the frame here is what
   stops them drifting apart again. */

export function SiteLayout(): ReactNode {
  return (
    <div className={s.shell}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <SiteHeader />

      <main className={s.main} id="main">
        <div className={s.gridBackdrop} aria-hidden="true" />
        <div className={s.content}>
          <Outlet />
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}
